import React, { Component } from 'react';
import styles from '../../styles/request.module.css';
import i18next from 'i18next';
import { isAuthenticated } from '../../actions/authentication';
import TabPanelRequest from './TabPanelRequest'
import { withNamespaces } from 'react-i18next';
import { withCookies } from 'react-cookie';
import { RenewToken } from '../../utils/token';
import { ChatContext } from '@/ChatProvider';

class Request extends Component {
    constructor(props) {
        super(props)

        this.state = { authenticated: false }
    }

    componentDidMount() {
        this.handleTitle();

        this.handleToken();
    }

    async handleToken() {
        await RenewToken(this.props);

        isAuthenticated().then((result) => {
            this.setState({ authenticated: result });
            this.context.setIsAuthenticated(result);
        });
    }

    handleTitle() {
        this.props.onLoadTitle(i18next.t('menu:request'));
    }

    render() {
        return (
            this.state.authenticated && <div className={styles.rootRequest }>
                <TabPanelRequest />
            </div>
        );
    }
}

Request.contextType = ChatContext;
export default withNamespaces(['menu'], { wait: true })(withCookies(Request));